import { Link } from "react-router-dom";
import { scrollToId } from "./Reveal";

export default function Footer() {
  return (
    <footer className="relative bg-ecdeep text-white overflow-hidden" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 pb-14 border-b border-white/10">
          <div>
            <div className="inline-flex items-center bg-white rounded-2xl px-5 py-3" data-testid="footer-logo">
              <img src="/assets/eclickgo-logo.webp" alt="eClickGo" className="h-9 w-auto" />
            </div>
            <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-sm">
              Soluciones Tecnológicas para Retail y Empresas.
            </p>
            <p className="mt-1 text-sm text-white/60">Portafolio Corporativo 2026.</p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-5">Navegación</p>
            <ul className="space-y-3 text-sm">
              {[
                ["nosotros", "Nosotros"],
                ["capacidades", "Capacidades"],
                ["soluciones", "Soluciones para Retail"],
                ["contacto", "Contacto"],
              ].map(([id, label]) => (
                <li key={id}>
                  <button onClick={() => scrollToId(id)} className="text-white/70 hover:text-ecamber transition-colors duration-200" data-testid={`footer-link-${id}`}>
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-5">Contacto</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li>
                <a href="https://wa.me/525516836714" target="_blank" rel="noopener noreferrer" className="hover:text-ecamber transition-colors duration-200">
                  WhatsApp: +52 55 1683 6714
                </a>
              </li>
              <li>
                <a href="mailto:soluciones@eclick.mx" className="hover:text-ecamber transition-colors duration-200">Correo: soluciones@eclick.mx</a>
              </li>
              <li className="text-white/60">Próximamente nuestro sitio web: eclickgo.com</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 space-y-3" data-testid="footer-legal">
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs">
            <Link to="/terminos-y-condiciones" className="text-white/60 hover:text-ecamber transition-colors duration-200" data-testid="footer-link-terminos">
              Términos y Condiciones
            </Link>
            <Link to="/aviso-de-privacidad" className="text-white/60 hover:text-ecamber transition-colors duration-200" data-testid="footer-link-privacidad">
              Aviso de Privacidad
            </Link>
          </div>
          <p className="text-xs text-white/40 leading-relaxed">
            RFC: SCE240920SZ1 · Paseo las Américas Núm. 31, Col. Lomas Verdes 3ra Secc., Naucalpan de Juárez, Estado de México, C.P. 53125
          </p>
          <p className="text-xs text-white/40">© 2026 eClick México. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
